// src/auth/ProtectedRoute.tsx
import type { ReactNode } from "react";
import RequireAuth from "./guards/RequireAuth";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  return <RequireAuth>{children}</RequireAuth>;
}
